import React from 'react';

const LoginContext = React.createContext();

const contexts = {
  LoginContext,
};

export default contexts;
